import { useHotkey } from '@tanstack/react-hotkeys';

export const useFeatureFlagShortcut = (callback: () => void, enabled = true) => {
  // Mac produces '¿' for Alt+Shift+/, Windows produces '/'
  useHotkey({ key: '¿', alt: true, shift: true }, callback, {
    stopPropagation: true,
    requireReset: true,
    enabled,
    target: window,
    eventType: 'keydown',
  });
  useHotkey({ key: '/', alt: true, shift: true }, callback, {
    stopPropagation: true,
    requireReset: true,
    enabled,
    target: window,
    eventType: 'keydown',
  });
};
